<app-form-field label='Critères' required [control]="formControl">
  <app-multiselector [items]='allCriteres'
                     valueIdProperty='id'
                     valueCaptionProperty='libelle'
                     [formControl]='formControl'
                     [detailedDeletionMode]='false'
                     [isError]="isError">
  </app-multiselector>
</app-form-field>
